import React from 'react'

const BeautyNhygiene = () => {
  return (
    <div>
        <h1 style={{marginTop:"50px"}}>Beauty & Hygiene</h1>
    <div className='Beverages'>
        <div >
            <img style={{height:"450px",cursor:"pointer"}} src="https://www.bigbasket.com/media/customPage/77880b23-0233-4fad-b54a-a93c998e0d20/7f6ddfd5-93af-4bbd-a250-ce828daa63d6/6fe7b988-d217-4451-a8ff-6ddd2762f3d5/hp_beauty-Storefront_m_251022_560x378_01.jpg" alt="Not-Found" />
        </div>
        <div>
            <div >
                <img style={{height:"203px",cursor:"pointer"}}  src="https://www.bigbasket.com/media/customPage/77880b23-0233-4fad-b54a-a93c998e0d20/7f6ddfd5-93af-4bbd-a250-ce828daa63d6/6fe7b988-d217-4451-a8ff-6ddd2762f3d5/hp_beauty-Storefront_m_251022_275x184_02.jpg" alt="Not-Found" />
                <img style={{height:"203px",cursor:"pointer"}} src="https://www.bigbasket.com/media/customPage/77880b23-0233-4fad-b54a-a93c998e0d20/7f6ddfd5-93af-4bbd-a250-ce828daa63d6/6fe7b988-d217-4451-a8ff-6ddd2762f3d5/hp_beauty-Storefront_m_251022_275x184_03.jpg" alt="Not-Found" />
            </div>
            <div >
                <img style={{height:"203px",cursor:"pointer"}} src="https://www.bigbasket.com/media/customPage/77880b23-0233-4fad-b54a-a93c998e0d20/7f6ddfd5-93af-4bbd-a250-ce828daa63d6/6fe7b988-d217-4451-a8ff-6ddd2762f3d5/hp_beauty-Storefront_m_251022_275x184_04.jpg" alt="Not-Found" />
                <img style={{height:"203px",cursor:"pointer"}} src="https://www.bigbasket.com/media/customPage/77880b23-0233-4fad-b54a-a93c998e0d20/7f6ddfd5-93af-4bbd-a250-ce828daa63d6/6fe7b988-d217-4451-a8ff-6ddd2762f3d5/hp_beauty-Storefront_m_251022_275x184_05.jpg" alt="Not-Found" />
            </div>
        </div>
    </div>
    </div>
  )
}

export default BeautyNhygiene